<template>
  <div class="tooltip">
    <div class="tooltip__title" :class="{ item: type === 'deliveryItem' }">
      <img :src="require('@/assets/img/ic_qmark.svg')" />
      <div>
        <div v-html="getTitle"></div>
        <div class="tooltip__content" v-html="getContent"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["type"],
  data() {
    return {
      content: null,
      title: null,
      weightFee: {
        title: "배송물건의 무게에 따라 차등 적용됩니다.",
        content: ` 3kg 이하 : 0원 / 5kg 이하 : 3,000원 <br/>
          10kg 이하 : 5,000원 / 20kg 이하 : 7,000원 <br/>
          20kg 초과 : 추가 20kg 당 4,000원씩 부과`,
      },
      distanceFee: {
        title: "배송 거리에 따라 차등 적용됩니다.",
        content: `3km 이상~5km 미만 2,000원 <br/>
          5km 이상 시 1km당 500원`,
      },
      waypointsFee: {
        title: "경유지 한 개소당 4,000원의 요금이 적용됩니다.",
        content: "",
      },
      timeChargeFee: {
        title: "픽업시간에 따라 차등 적용됩니다.",
        content: `06시~08시 이전 : 기준 운임의 20% 할증<br/>
            16시~18시 이전 : 기준 운임의 20% 할증<br/>
            18시~22시 이전 : 기준 운임의 40% 할증<br/>
            22시~익일 06시 이전 : 기준 운임의 100% 할증 (단, 최대 할증금액 50,000원)`,
      },
      weatherChargeFee: {
        title: "당일 기상상황에 따라 차등 적용됩니다.",
        content: `우천/설천 등 악천후 시 : 기준 운임의 10~20% 할증 <br/>
            폭염/한파/기타 기상주의보 : 기준 운임의 20% 할증 <br/>
            폭염/한파/기타 기상경보 : 기준 운임의 30% 할증 <br/>
            태풍/호우/대설 기상주의보 : 기준 운임의 30% 할증 <br/>
            태풍/호우/대설 기상경보 : 기준 운임의 50% 할증`,
      },
      specialDayChargeFee: {
        title:
          "배송 혼잡도가 높은 특수일인 경우, 픽업일 기준으로 차등 적용됩니다.",
        content: `토, 일, 공휴일 : 기준 운임의 20% 할증 (단, 특수일인 경우 특수일 할증 적용) <br/>
        명절, 각종 기념일, 크리스마스 전후 : 기준운임의 30% 할증
        `,
      },
      freightWaypointsFee: {
        content: "",
        title: `다마스, 라보 차량의 경우, 경유지 한 개소당 4,000원의 요금이 적용됩니다. <br/>
          1톤~25톤 차량의 경우, 경유지 한 개소당 10,000원의 요금이 적용됩니다.`,
      },
      freightOptionsFee: {
        title:
          "선택한 차종, 차량특성, 상/하차옵션에 따라 옵션 요금이 적용됩니다.",
        content: "",
      },
      deliveryItem: {
        title: `소박스: A4박스 크기 - 오토바이 가능 <br/>
        대박스: 사과박스 크기 - 오토바이 불가능`,
        content: "",
      },
    };
  },
  computed: {
    getContent() {
      const type = this.type;
      return this[type].content || "";
    },
    getTitle() {
      const type = this.type;
      return this[type].title || "";
    },
  },
};
</script>
<style scoped>
.tooltip {
  box-sizing: border-box;
  border: 1px solid var(--gray-500);
  background-color: var(--white);
  border-radius: 8px;
  padding: 8px;
  /* min-width: 280px;
  width: max-content; */
  width: 280px;
  z-index: 99999999;
}

.tooltip__title {
  box-sizing: border-box;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: var(--gray-600);
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.item {
  box-sizing: border-box;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: var(--gray-500);
  align-items: flex-start;
}

.tooltip__content {
  box-sizing: border-box;
  word-break: break-all;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: var(--gray-500);
}

@media all and (max-width: 1023px) {
  .tooltip {
    width: 300px;
  }
}
</style>
